/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import CommonButton from 'app/common/Component/Button/CommonButton';
import Popup from 'app/common/Component/Popup/Popup';
import TableComponent from 'app/common/Component/Table/TableComponent';
import { Form, Formik, useFormikContext } from 'formik';
import { useStore } from "app/stores";
import BlockIcon from '@material-ui/icons/Block';
import { useTranslation } from "react-i18next";
import { observer } from 'mobx-react';
import { formatMoney, getDateTime } from 'app/common/LocalFunction';
import history from "history.js";
import Config from "app/appConfig";
import { PathModule, SERVICE_TREATMENT_TYPE } from 'app/common/LocalConst';
import { PhoneNumberCell } from 'utils';
function PopupHistoryTreament({
    open,
    handleClose
}) {
    const { t } = useTranslation();
    const { setFieldValue, values } = useFormikContext();
    const [selectedRows, setSelectedRows] = useState([]);
    const {
        pageHistoryServiceRequestItem,
        searchHistory,
        handleChangeFormSearchHistory
    } = useStore().patientManagementStore.serviceRequestItemStore;


    return (
        <Popup
            open={open}
            handleClose={handleClose}
            title={"Lịch sửa điều trị"}
            height={"360px"}
            action={
                <>
                    <CommonButton className="btn-gray" onClick={handleClose} >
                        <BlockIcon /> {t('cancel')}
                    </CommonButton>
                </>
            }
        >
            <Formik
                initialValues={{}}
                onSubmit={handleChangeFormSearchHistory}
                enableReinitialize
            >
                {({ setFieldValue }) => {
                    return (
                        <Form autoComplete='off'>
                            <section className="cards-container">
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TableComponent
                                            className=""
                                            showOrdinalNumbers
                                            titleNodata={"Không có dữ liệu"}
                                            data={pageHistoryServiceRequestItem?.content || []}
                                            columns={[
                                                {
                                                    field: "displayName",
                                                    title: t("Tên khách hàng"),
                                                    render: (patient) => (
                                                        <div >
                                                            <Tooltip title="Thông tin khách hàng">
                                                                <div>
                                                                    <p>
                                                                        <b>{patient?.fullName}</b>
                                                                    </p>
                                                                    <p className="flex">
                                                                        <b style={{ color: "#4276a4" }}>
                                                                            {patient?.code}{" "}
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    ),
                                                    fixed: true,
                                                },
                                                {
                                                    field: "patient.phoneNumber",
                                                    title: t("Số điện thoại"),
                                                    render: (rowData) => (
                                                        <PhoneNumberCell value={rowData?.patient?.phoneNumber} />
                                                    ),
                                                },
                                                {
                                                    field: "logDate",
                                                    title: "Thời gian log",
                                                    align: "right",
                                                    render: (row) => <b>{getDateTime(row?.logDate)}</b>,
                                                },
                                                {
                                                    field: "modifiedBy",
                                                    title: "Tài khoản thay đổi",
                                                    render: (row) => row?.modifiedBy || row?.createdBy || "",
                                                },
                                                {
                                                    field: "createDate",
                                                    title: "Thời gian tạo",
                                                    align: "right",
                                                    render: (row) => getDateTime(row?.createDate),
                                                },
                                                {
                                                    field: "orderDate",
                                                    title: "Ngày chỉ định",
                                                    align: "right",
                                                    render: (row) => getDateTime(row?.orderDate),
                                                },
                                                {
                                                    field: "department",
                                                    title: "Cơ sở",
                                                    render: (row) => row?.department?.name || "",
                                                },
                                                {
                                                    field: "assigner",
                                                    title: "Người chỉ định",
                                                    render: (row) => row?.assigner?.staffName || "",
                                                },
                                                {
                                                    field: "serviceName",
                                                    title: "Tên dịch vụ",
                                                },
                                                {
                                                    field: "treatmentType",
                                                    title: "Loại điều trị",
                                                    align: "center",
                                                    render: (row) =>
                                                        SERVICE_TREATMENT_TYPE?.find(
                                                            (el) => el.value === row?.treatmentType
                                                        )?.name || "",
                                                },
                                                {
                                                    field: "totalPerformedTimes",
                                                    title: "Lần",
                                                    align: "center",
                                                },
                                                {
                                                    field: "totalTreatmentTimes",
                                                    title: "Tổng số lần",
                                                    align: "center",
                                                },
                                                {
                                                    field: "currentVolumeTreated",
                                                    title: "Số lượng điều trị",
                                                    align: "center",
                                                },
                                                {
                                                    field: "warrantyServiceName",
                                                    title: "Dịch vụ bảo hành",
                                                },
                                                {
                                                    field: "encounterParticipants",
                                                    title: "Người thực hiện",
                                                    render: (row) =>
                                                        row?.encounterParticipants
                                                            ?.map((p) => p?.staff?.staffName)
                                                            ?.join(", "),
                                                },
                                                {
                                                    field: "wage",
                                                    title: "Tiền công",
                                                    align: "right",
                                                    render: (row) =>
                                                        row?.encounterParticipants
                                                            ?.map((p) => formatMoney(p?.wage))
                                                            ?.join(", "),
                                                },
                                                {
                                                    field: "locked",
                                                    title: "Trạng thái",
                                                    align: "center",
                                                    render: (row) =>
                                                        row?.encounterParticipants?.some((p) => p?.locked)
                                                            ? "Đã khóa"
                                                            : "Chưa khóa",
                                                },
                                            ]}
                                            dataPagination={{
                                                pageIndex: searchHistory?.pageIndex,
                                                pageSize: searchHistory?.pageSize,
                                                totalElements: pageHistoryServiceRequestItem?.totalElements,
                                                totalPages: pageHistoryServiceRequestItem?.totalPages,
                                                setPageIndex: (pageIndex) =>
                                                    handleChangeFormSearchHistory({ pageIndex }),
                                                setPageSize: (pageSize) =>
                                                    handleChangeFormSearchHistory({ pageSize }),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </section>
                        </Form>
                    );
                }}
            </Formik>
        </Popup>
    );
}

export default memo(observer(PopupHistoryTreament));
